import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import VehicleJobSection from "./VehicleJobSection";
import NotificationManager from "react-notifications/lib/NotificationManager";
import {Heading, Table} from "react-bulma-components";
import { Form } from "react-bulma-components";
import shortid from "shortid";
import { Button } from "react-bulma-components";
import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import WorkSection from "./WorkSection";
import ContactSection from "../Contact/ContactSection";
import {
  createSetDataFreshAction, createSetFitterHourDataAction,
  createSetJobAction,
  createSetJobFieldAction, createSetVehicleDataAction
} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {
  getAppDefaultsData,
  getDataFresh, getDefaultWorkData, getDepartmentsData, getDriversData, getExistingJobsData, getFitterHoursData,
  getFittersData, getImagesData,
  getJobData, getKeysData,
  getMovementRatesData, getMovementsData, getMovementTypesData, getTrackingOptionsData,
  getWorkTypeData
} from "../../state/selectors";
import Validator from "./Validator";
import ReactToPrint from "react-to-print";
import PrintJob from "./PrintJob";
import PartSearchModal from "./PartSearchModal";
import {
  getPartCustomerCost,
  fixEmptyDates,
  fixEmptyDepartment,
  hasApprovedWork,
  getWorkTotals,
  readableDate, toDate, formatDate
} from "../../utils";
import useSafeSave from "../../hooks/useSafeSave";
import DeleteWarningModal from "../Modal/DeleteWarningModal";
import TopSummary from "./TopSummary";
import ApprovalModal from "./ApprovalModal";
import Comment from "./Comment";
import WorkSearchModal from "./WorkSearchModal";
import PrintVehicleCheckInSheet from "./PrintVehicleCheckInSheet";
import FitterSelector from "./FitterSelector";
import KeyChangeModal from "./KeyChangeModal";
import DefectJobSection from "./Defects/DefectJobSection";
import WorkshopInstructions from "./WorkshopInstructions";
import ExistingItemModal from "./ExistingItemModal";

import ImageModal from "./ImageModal";
import PartEnquiryJobSection from "./Part Enquiry/PartEnquiryJobSection";
import ToQuoteModal from "./Part Enquiry/ToQuoteModal";
import ContactModal from "./ContactModal";
import VehicleMileageWarning from "./VehicleMileageWarning";
import CreateMovement from "../Movement/CreateMovement";
import {useMovementsData} from "../../hooks/useMovementsData";
import MovementSection from "./MovementSection";
import {useImagesData} from "../../hooks/useImagesData";
import CashSaleSection from "../Contact/CashSaleSection";
import useInput from "../../hooks/useInput";
import FitterHours from "./HourCalandar/FitterHours";
import {useFitterHourData} from "../../hooks/useFitterHourData";
import VehicleInspectionRow from "./VehicleInspectionRow";
import PrintJobQuoteOptionsModal from "./PrintJobQuoteOptionsModal";
import DefaultWorkItemsSection from "./DefaultWorkItemsSection";
import {useExistingJobData} from "../../hooks/useExistingJobData";
import LoadingSpinner from "../Utils/Spinner";

function JobForm(props) {

  const printJobSheetRef = useRef();
  const printVehicleCheckInRef = useRef();

  const dateFields = ["book_in_date", "workshop_date", "finish_date", "date_created"];
  const [lastChange, setLastChange] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [enquiryToQuoteModalOpen, setEnquiryToQuoteModalOpen] = useState(false);
  const [instructionModalOpen, setInstructionModalOpen] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [keyModal, setKeyModal] = useState(false);
  const [similarModal, setSimilarModal] = useState(false);
  const [associatedItems, setAssociatedItems] = useState([]);
  const [mileageWarningModal, setMileageWarningModal] = useState(false);
  const [movementModal, setMovementModal] = useState(false);
  const [showFitterHours, setShowFitterHours] = useState(false);
  const [fitterNoFetch, setFitterNoFetch] = useState(false);
  const [fitterLoading, setFitterLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [printOptionsModalOpen, setPrintOptionsModalOpen] = useState(false);
  const [removedDefaultWorkItems, setRemovedDefaultWorkItems] = useState([]);

  let today = new Date();
  let daysLater = new Date();
  daysLater.setDate(daysLater.getDate() + 28);

  const dispatch = useDispatch();
  const fitters = useSelector(getFittersData)
  let job = useSelector(getJobData);
  let workTypes = useSelector(getWorkTypeData);
  let appDefaults = useSelector(getAppDefaultsData);
  let movementRates = useSelector(getMovementRatesData);
  let movementTypes = useSelector(getMovementTypesData);
  let drivers = useSelector(getDriversData);
  let dataFresh = useSelector(getDataFresh);
  let movementsLoaded = useMovementsData({job: job.id ?? 0}, dataFresh);
  let movements = useSelector(getMovementsData);
  let trackingOptions = useSelector(getTrackingOptionsData);
  let departments = useSelector(getDepartmentsData);
  let keys = useSelector(getKeysData);
  let defaultWork = useSelector(getDefaultWorkData);
  const invoiced = job.customer_invoice_number && job.customer_invoice_number;
  let imageParams = {type: "job"}
  let existingJobParams = {};
  if(job && job.vehicle){
        imageParams.blob_name = job.vehicle.registration+"-"+job.id;
        imageParams.id = job.id
        existingJobParams.vehicle = job.vehicle.id;
  }
  let imagesLoaded = useImagesData(imageParams, dataFresh);
  let images = useSelector(getImagesData);
  let existingJobsLoaded = useExistingJobData(existingJobParams);
  let existingJobs = useSelector(getExistingJobsData);

  const onRemoveDefaultItem = (item) => {
    let newRemovedItems = [...removedDefaultWorkItems];
    newRemovedItems.push(item.id);
    setRemovedDefaultWorkItems(newRemovedItems);
  }

  const onAddDefaultItem = (item) => {
    let newRemovedItems = [...removedDefaultWorkItems];
    let index = newRemovedItems.indexOf(item.id);
    if (index !== -1){
      newRemovedItems.splice(index, 1);
    }
    setRemovedDefaultWorkItems(newRemovedItems);
  }


  const onFitterHourStartChange = (e) => {
    setFitterNoFetch(true);
    setFitterLoading(true);
    setSelectedDate(null);
    let url =`${props.endpoint}/fittersummary?start=${e.target.value}&end=${fitterEnd}`
    if(job.fitter){
      url = url+`&fitter=${job.fitter.id}`
    }
    const conf = {
      url: url,
      method: "get"
    }
    axios(conf).then(res =>{
      dispatch(createSetFitterHourDataAction(res.data));
      setFitterLoading(false);
    }).catch(err => {
      NotificationManager.error("There was an error getting fitter breakdown");
    })
  };

  const onFitterHourEndChange = (e) => {
    setFitterNoFetch(true);
    setFitterLoading(true);
    setSelectedDate(null);
    let url =`${props.endpoint}/fittersummary?start=${fitterStart}&end=${e.target.value}`
    if(job.fitter){
      url = url+`&fitter=${job.fitter.id}`
    }
    const conf = {
      url: url,
      method: "get"
    }
    axios(conf).then(res =>{
      dispatch(createSetFitterHourDataAction(res.data));
      setFitterLoading(false);
    }).catch(err => {
      NotificationManager.error("There was an error getting fitter breakdown");
    })
  };

  const onClick = item => {
    let editUrl = item.itemType === "Job" ? "editjob" : "editquote";
    props.history.push(`/${editUrl}/${item.id}`);
  };

  const [fitterStart, fitterStartInput, setFitterStart] = useInput({
      type: "date",
      initialValue: job.book_in_date ? job.book_in_date : formatDate(today),
      label:"Start Date",
      onChange: onFitterHourStartChange
  });

  const [fitterEnd, fitterEndInput, setFitterEnd] = useInput({
      type: "date",
      initialValue: formatDate(daysLater),
      label: "End Date",
      onChange: onFitterHourEndChange
  });
  let fitterHourParams = {
    start: fitterStart,
    end: fitterEnd
  }
  if(job && job.fitter){
    fitterHourParams.fitter = job.fitter.id
  }

  let fitterHoursLoaded = useFitterHourData(fitterHourParams, dataFresh, fitterNoFetch);
  const fitterHoursData = useSelector(getFitterHoursData);

  const [partsModalState, setPartsModalState] = useState({
    modalOpen: false,
    currentSearch: "",
    searchText: "",
    partIndex: 0,
    workIndex: 0
  });

  const [workModalState, setWorkModalState] = useState({
    modalOpen: false,
    currentSearch: "",
    searchText: "",
    workIndex: 0
  });

  const customerPaymentOptions = [
    {name:"", value: "BLANK"},
    {name: "BACS", value: "BACS"},
    {name: "CASH", value: "CASH"},
    {name: "CARD", value: "CARD"},
    {name: "DIRECT DEBIT", value: "DIRECT DEBIT"}
  ];

  const addWorkItem = (description, workTypeObject=null) => {
    triggerChange({
      work_items: job.work_items.concat({
        key: shortid.generate(),
        chargeable: !!job.customer2,
        labour_cost: 0,
        estimated_labour_cost: 0,
        customer_labour_cost: 0,
        estimated_customer_labour_cost: 0,
        labour_hours: 0,
        estimated_labour_hours: 0,
        parts: [],
        quote: job.quote,
        added_after_quote: true,
        job: job.id || undefined,
        complete: false,
        supplier_tracking_option: null,
        customer_tracking_option: null,
        description: description ? description : "",
        work_type: workTypeObject ? workTypeObject : null
      })
    });
  };

  const addComment = (e) => {
    e.preventDefault();
    triggerChange({
      comments_list: job.comments_list.concat({
        key: shortid.generate(),
        text: "",
        job: job.id || undefined
      })
    })
  };

  const checkNotUpdated = () => {
    if (job.id) {
      return axios
        .get(props.endpoint + "jobs/" + job.id)
        .then(
          result => {
            return (new Date(result.data.last_saved).getTime() -
              new Date(job.last_saved).getTime()) /
            1000 <
            1}
        ).catch(err => {
          NotificationManager.error("An error occurred!");
        });
    }
    return new Promise((res, rej) => res(true));
  };

  const searchSelectPart = (part, partIndex, workIndex) => {
    let newWorkItem = job.work_items[workIndex];
    let customer = newWorkItem.chargeable ? job.customer2 : job.customer;

    let newPart = {
      name: part.name,
      part_number: part.part_number,
      supplier: part.supplier,
      cost: part.cost,
      estimated_cost: 0,
      customer_cost: getPartCustomerCost(part, customer, appDefaults),
      estimated_customer_cost: 0,
      created_from_lookup: part.id
    };

    newWorkItem.parts[partIndex] = {
      ...newWorkItem.parts[partIndex],
      ...newPart
    };

    updateWork(newWorkItem, workIndex);
    setPartsModalState({...partsModalState, modalOpen: false});
  };
  const partLookupToParts = (lookup) => {
    let part = {
      part_number: lookup.part_number,
      cost: lookup.cost,
      customer_cost: lookup.customer_cost,
      supplier: lookup.supplier,
      name: lookup.name,
    }
    if(lookup.customer_cost === 0) {
      part.customer_cost = getPartCustomerCost(part, job.customer2 ? job.customer2 : job.customer, appDefaults);
    }

    return part;
  }

  const filterInstructions = (instruction) => {
        return instruction.on_completion
  }
  const searchSelectWork = (work, workIndex) => {
    let parts = [];
    work.part_work_lookup.map(part => {
      parts.push(partLookupToParts(part))
    })

    let newWorkItem = {
      key: shortid.generate(),
      description: work.description,
      chargeable: !!job.customer2,
      labour_cost: work.labour_cost,
      estimated_labour_cost: 0,
      customer_labour_cost: work.customer_labour_cost,
      estimated_customer_labour_cost: 0,
      labour_hours: work.labour_hours,
      estimated_labour_hours: 0,
      parts: parts,
      quote: job.quote,
      added_after_quote: true,
      job: job.id || undefined,
      cost_override: true
    };
    triggerChange({
      work_items: job.work_items.concat(newWorkItem)
    });
    setWorkModalState({...workModalState, modalOpen: false});
  };

  const onSearchPartClick = (part, partIndex, workIndex) => {
    const searchText = [
      job.vehicle ? job.vehicle.make ? job.vehicle.make.name : "" : "",
      job.vehicle.type ? job.vehicle.type.name : "",
      part.name
    ].join(" ");

    setPartsModalState({
      modalOpen: true,
      currentSearch: searchText,
      workIndex,
      partIndex,
      searchText
    });
  };
  const triggerChange = (data, name) => {
    makeDirty();
    setLastChange(new Date());
    dispatch(createSetJobFieldAction(data));
  };

  const handleVehicleDataChange = vehicle => {
    triggerChange({vehicle});
  }

  const onDefectChange = e =>{
    triggerChange({[e.target.name]: e.target.value});
  }

  const updateWork = (work, index) => {
    let newWorkItems = [...job.work_items];
    newWorkItems.splice(index, 1, work);
    triggerChange({work_items: newWorkItems});
  };

  const removeWorkItem = index => {
    let newWorkItems = [...job.work_items];
    if(newWorkItems[index].description !== "" && newWorkItems[index].description !== null){
      let newComment = {
        key: shortid.generate(),
        text: `Removed Work Item ${newWorkItems[index].description}`,
        job: job.id || undefined
      }
      triggerChange({comments_list: job.comments_list.concat(newComment)})
    }
    newWorkItems.splice(index, 1);
    triggerChange({work_items: newWorkItems});
  };

  const updateComment = (comment, index) => {
    let newComments = [...job.comments_list];
    newComments.splice(index, 1, comment);
    triggerChange({comments_list: newComments});
  };

  const removeComment = index => {
    let newComments = [...job.comments_list];
    newComments.splice(index, 1);
    triggerChange({comments_list: newComments});
  };

  const handleChange = e => {
    const {name, value} = e.target;
    if(name === 'mileage'){
      triggerChange({[name]: value}, name);
    }
    else{
      triggerChange({[name]: value});
      if(name === "book_in_date"){
        setFitterStart(value);
      }
      // if customer 1 or 2 paid amount is changed, tick cost override
      if(name === "customer1_paid_amount"){
        let workItems = [...job.work_items];
        workItems.filter(item => item.chargeable === false).forEach(work => {
          work.cost_override = true;
        });
        triggerChange({"work_items": workItems});
      }
      else if(name === "customer2_paid_amount"){
        let workItems = [...job.work_items];
        workItems.filter(item => item.chargeable === true).forEach(work => {
          work.cost_override = true;
        });
        triggerChange({"work_items": workItems});
      }
    }
  };

  const handleHistoryChange = e => {
    const {name, value} = e.target;
    triggerChange({['history']: value});
  }

  const onCheck = name => {
    triggerChange({[name]: !job[name]});
  };

  const onWashNeededTick = (name, workTypeObjects) => {
    // Passing work type objects is a lazy way of getting around it not being defined at this func def
    if(!job[name]){
      // the bool is being updated to true as it is currently false
      addWorkItem("Wash Needed", workTypeObjects[9]);
    }
    onCheck(name)
  }

  const handleUpdateHireCustomer = e => {
    triggerChange({customer2: e});
    if (!e) {
      let newWorkItems = job.work_items.map(item => {
        return {...item, chargeable: false};
      });
      triggerChange({work_items: newWorkItems});
    }
  };
  const onKeyClear = (spare) => {
      const url = "/api/vehicles/clearkey";
      let conf = {
          data: {'vehicle': job.vehicle, 'spare': spare},
          url: url,
          method: "put"
      };
      return axios(conf)
          .then((res) => {
            dispatch(createSetDataFreshAction(dataFresh +1))
          }).catch(err => {
            NotificationManager.error("There was an error\n"+err)
          });
  };

  const handleStatus = status => {
     return safeSave().then(statusChange(status))
      .catch(reason => {
        NotificationManager.error("Unable to change job status");
      });
  }

  const handleApprove = e => {
    if (job.mileage) {
      safeSave()
        .then(approve)
        .catch(reason => {
          NotificationManager.error("Unable to approve job");
        });
    } else {
      NotificationManager.error("You must specify a mileage before approving!");
    }
  };

  const handleSave = e => {
    e.preventDefault();
    safeSave().then().catch(err => {NotificationManager.error("An error occurred!")});
  };

  const vehicleSave = () => {
    let vehicleToSave = job.vehicle;
    const endpoint = props.endpoint + "/vehicles/"+vehicleToSave.id;

    const conf = {
      method: "put",
      data: vehicleToSave,
      url: endpoint
    };
    return axios(conf).then(resp => {
      dispatch(createSetVehicleDataAction(resp.data));
    }).catch(err => {NotificationManager.error("An error occurred!")});
  }


  const statusChange = (status) => {
    let newJob = job;
    const url = props.endpoint + "jobs/returned/" + job.id;
    newJob.status = status;

    axios.put(url, newJob).then(response => {
      dispatch(createSetJobAction(response.data))
    }).catch(reason => {
      NotificationManager.error("An error occurred!")
    });
  };

  const validateAttachedInspections = (job) => {
    if(job.attached_inspections){
      let valid = true;
      job.attached_inspections.forEach(ins => {
        if(!(!!ins.new_expiry_date)){
          valid = false;
        }
        if(!(!!ins.new_completed_date)){
          valid = false;
        }
      })
      return valid
    }
    // if there are no inspections this should not stop the job from being approved
    return true;
  }
  const validateParts = job => {
    let valid = true;
    let invalidParts = []
    job.work_items.forEach(work => {
      work.parts.forEach(part => {
        if(!part.to_be_ordered && !part.backorder && !(!!part.backorder_expected_date) && !(!!part.date_ordered) && !part.from_stock){
          valid = false;
          invalidParts.push(part.name || "Unnamed Part");
        }
      });
    });
    invalidParts.forEach(part => {
      NotificationManager.warning(`Part ${part} needs to be ordered`)
    })
    return valid
  }
  const approve = () => {
    if(validateParts(job)) {
      if (job.workshop_date) {
        if (validateAttachedInspections(job)) {
          const endpoint = props.endpoint + "jobs/approve/" + job.id;
          const conf = {
            method: "post",
            url: endpoint
          };
          axios(conf).then(response => dispatch(createSetJobAction(response.data)));
        } else {
          NotificationManager.warning("New Completed Date and New Expiry Date are required before approval")
        }
      } else {
        NotificationManager.warning("Workshop date is required before approval")
      }
    }
  };
  const save = () => {
    let jobToSave = fixEmptyDates(job, dateFields);
    jobToSave = fixEmptyDepartment(job);
    if(!(!!jobToSave.id)){
      // we only need to worry about default work items when a job is being created
      jobToSave.removed_default_work = removedDefaultWorkItems;
    }
    mileageWarning();
    const endpoint = jobToSave.id
      ? props.endpoint + "jobs/" + jobToSave.id
      : props.endpoint + "createjob";
    const method = jobToSave.id ? "put" : "post";

    const conf = {
      method: method,
      data: jobToSave,
      url: endpoint
    };
    return axios(conf).then(resp => {
      dispatch(createSetJobAction(resp.data));
      if (!jobToSave.id) {
        props.history.push("/editjob/" + resp.data.id);
      }
    }).catch(err => {NotificationManager.error("An error occurred!")});
  };

  const [makeDirty, safeSave] = useSafeSave(
    save,
    lastChange,
      (!job.is_defect && !job.is_enquiry) ? (() => Validator(job, true)) : null,
    checkNotUpdated
  );

  const handleDelete = () => {
    const endpoint = props.endpoint + "jobs/" + job.id;
    const conf = {method: "delete", url: endpoint};
    axios(conf).then(response => props.history.push("/jobs"));
  };

  const defectToQuote = () => {
    if(job.customer || job.customer2) {
      const conf = {
        data: job,
        method: "post",
        url: props.endpoint + "defectquote"
      }
      axios(conf).then((res) => {
        if (res.data.id) {
          props.history.push("/editquote/" + res.data.id);
        }
      }).catch((err) => {
        NotificationManager.error("An error occurred!")
      });
    }
    else {
      NotificationManager.error("A customer is required");
    }
  };

  const onInspectionAdd = (inspection) => {
    // this function needs to handle all things that happen when an inspection is attached to a job
    // job will take on a new array called attached_inspections
    // This array will only be populated by this and will not be used by the serializer
    // This array will be passed to the view which will then create the needed link table records
    // job will then have a serializer method field for an array of inspection ids that are currently attached to stop the same inspection being attached again
    let attached_inspections = job.attached_inspections ? job.attached_inspections : [];
    attached_inspections.push(inspection);
    triggerChange({attached_inspections});
    addWorkItem(inspection.inspection_type);
  }

  const getAllJobsQuotes = (vehicle) => {
    axios
      .all([
        axios.get(props.endpoint + `quotes?vehicle=${vehicle.id}&ready_for_customer_invoice=false`),
        axios.get(
          props.endpoint + `jobs?vehicle=${vehicle.id}&view=not_finished&ws=all`
        )
      ])
      .then(
        axios.spread((estimateResp, jobResp) => {
          if (
              jobResp.data.results.length ||
              estimateResp.data.results.length
          ) {
            setAssociatedItems(
                jobResp.data.results.filter((j) => j.id !== job.id)
                    .map(jobData => {
                      return {...jobData, itemType: "Job"};
                    })
                    .concat(
                        estimateResp.data.results.map(estimateData => {
                          return {...estimateData, itemType: "Quote"};
                        })
                    )
            );
            setSimilarModal(true);
          }
        })
      )
  }

  const handleContinue = () => {
    setSimilarModal(false);
  };

  const mileageWarning = () => {
      const warningPoint = job.vehicle.model ? job.vehicle.model.mileage_limit : null;
      if(warningPoint && job.mileage >= (warningPoint)){
        setMileageWarningModal(true);
      }
    }

  const handleUtilsParam = (params) => {
    params.filterObj = "movement_rate"
    params.filter = params.contact
    props.setUtilsParam(params)
  }

  const addCashSale = (customerID) => {
        let newCashSale = {
            name: "",
            email: "",
            phone: "",
            address :"",
            contact: customerID
        };
        job.cash_sale.push(newCashSale);
        triggerChange({cash_sale: job.cash_sale})
    };

  const onCashSaleChange = (e, index) => {
    let cashSale = {...job.cash_sale[index]};
    cashSale[e.target.name] = e.target.value;
    job.cash_sale[index] = cashSale;
    triggerChange({cash_sale: job.cash_sale});
  }

  const customer1CashSaleChange = (e, index) => {
    let cashSales = job.cash_sale.filter((sale) => sale.contact === job.customer.id);
    let targetCashSale = cashSales[index];
    let trueIndex = job.cash_sale.indexOf(targetCashSale);
    onCashSaleChange(e, trueIndex);
  }

  const customer2CashSaleChange = (e, index) => {
    let cashSales = job.cash_sale.filter((sale) => sale.contact === job.customer2.id);
    let targetCashSale = cashSales[index];
    let trueIndex = job.cash_sale.indexOf(targetCashSale);
    onCashSaleChange(e, trueIndex);
  }

  if(!props.loaded || !movementsLoaded || !existingJobsLoaded){
    return <LoadingSpinner/>
  }

    const workTypeObjects = workTypes.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});

    const movementTypeObjects = movementTypes.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});

    const movementRateObjects = movementRates.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});

    const driverObjects = drivers.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});

    const departmentObjects = departments.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});

    const trackingOptionObjects = trackingOptions.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
    }, {});


    if(!job.department){
      triggerChange({department: Object.values(departmentObjects)[0]})
    }
    const onDepartmentsChange = (e) => {
      const data = departmentObjects[e.target.value];
      triggerChange({department: data});
    };

    let autoFill = {}
    if(job.id){
      autoFill.job = job
    }
    if(job.vehicle){
      autoFill.vehicle = job.vehicle.registration
    }
    if(job.customer){
      let customers = [job.customer];
      if(job.customer2){
        customers.push(job.customer2)
      }
      autoFill.customers = customers;
    }
    if(job.department){
        autoFill.department = job.department
    }
    document.title = "Job - " + (job.vehicle && job.vehicle.registration ? job.vehicle.registration : "New");
    return (
      <div>
        <TopSummary
          quote={job.quote}
          job={job}
          customer_label={job.customer ? job.customer.display_name : "Customer"}
          customer2_label={
            job.customer2 ? job.customer2.display_name : "Customer 2"
          }
          itemType="Job"
          onSave={handleSave}
          handleChange={handleChange}
        ></TopSummary>
        <Columns>
          <Columns.Column>
            <VehicleJobSection
              handleVehicleChange={handleVehicleDataChange}
              customerVehicle={job.customer_vehicle}
              vehicleUpdate={handleVehicleDataChange}
              endpoint={props.endpoint}
              vehicle={job.vehicle ? job.vehicle : {}}
              history={props.history}
              type={"Job Card"}
              disabled={job.id && (job.is_defect || job.is_enquiry) }
              keys={keys}
              onKeyClear={onKeyClear}
              onInspectionAdd={onInspectionAdd}
              attached_inspections={job.attached_inspections}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <DefectJobSection
              job={job}
              onChange={onDefectChange}
              dataFresh={dataFresh}
              disabled={!job.is_defect}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <PartEnquiryJobSection
              job={job}
              disabled={!job.is_enquiry}
              onChange={onDefectChange}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <ContactSection
              title="Workshop"
              contactUpdate={workshop => triggerChange({workshop})}
              endpoint={props.endpoint + "contacts"}
              contact={job.workshop || {}}
              type="SP"
              disabled={job.is_defect || job.is_enquiry}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Columns>
              <Columns.Column>
                <ContactSection
                  title="Customer 1"
                  contactUpdate={customer => triggerChange({customer})}
                  endpoint={props.endpoint + "contacts"}
                  contact={job.customer || {}}
                  type="CC"
                  disabled={!!job.quote || job.is_defect || job.is_enquiry}
                  displayWorkshopInstructions
                  department={job.department}
                />
              </Columns.Column>
            </Columns>
            {(job.customer && job.customer.is_cash_sale) &&
              <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Cash Sale</Heading>
                    </Columns.Column>
                    {job.cash_sale.filter((sale) => sale.contact === job.customer.id).length == 0 &&
                    <Columns.Column>
                        <Button
                            color={"success"}
                            onClick={() => addCashSale(job.customer.id)}
                        >
                            Add Cash Sale +
                        </Button>
                    </Columns.Column>
                    }
                </Columns>
              </Box>
            }
            {(job.customer && job.customer.is_cash_sale) &&
                job.cash_sale.filter((sale) => sale.contact === job.customer.id).map((sale, index) => (
                    <Columns>
                        <Columns.Column>
                            <CashSaleSection
                                data={sale}
                                index={index}
                                addCashSale={addCashSale}
                                onChange={customer1CashSaleChange}
                            />
                        </Columns.Column>
                    </Columns>
                ))
            }
          </Columns.Column>
          <Columns.Column>
            <Columns>
              <Columns.Column>
                <ContactSection
                  title="Customer 2"
                  contactUpdate={handleUpdateHireCustomer}
                  endpoint={props.endpoint + "contacts"}
                  contact={job.customer2 || {}}
                  type="CC"
                  disabled={!!job.quote || job.is_defect || job.is_enquiry}
                  displayWorkshopInstructions
                  department={job.department}
                />
              </Columns.Column>
            </Columns>
            {(job.customer2 && job.customer2.is_cash_sale) &&
              <Box>
                <Columns>
                    <Columns.Column>
                        <Heading>Cash Sale</Heading>
                    </Columns.Column>
                    {job.cash_sale.filter((sale) => sale.contact === job.customer2.id).length == 0 &&
                    <Columns.Column>
                        <Button
                            color={"success"}
                            onClick={() => addCashSale(job.customer2.id)}
                        >
                            Add Cash Sale +
                        </Button>
                    </Columns.Column>
                    }
                </Columns>
              </Box>
            }
            {(job.customer2 && job.customer2.is_cash_sale ) &&
                job.cash_sale.filter((sale) => sale.contact === job.customer2.id).map((sale, index) => (
                    <Columns>
                        <Columns.Column>
                            <CashSaleSection
                                data={sale}
                                index={index}
                                addCashSale={addCashSale}
                                onChange={customer2CashSaleChange}
                            />
                        </Columns.Column>
                    </Columns>
                ))
            }
          </Columns.Column>
        </Columns>

        <Box>
          <h1 className="title">Job Info</h1>
          {images.length > 0 &&
            <Columns>
              <Columns.Column>
                <p className={"bold"}>This Job Has Attached Files</p>
              </Columns.Column>
            </Columns>
          }
          <form>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Department</Form.Label>
                  <Form.Control>
                    <Form.Select
                        name='department'
                        value={job.department ? job.department.id : 1}
                        onChange={onDepartmentsChange}
                        disabled={job.is_defect}
                    >
                      {departments.results.map(item => (
                        <option key={item.name} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Fitter</Form.Label>
                <Form.Control>
                  <FitterSelector
                    fitters={fitters}
                    value={job.fitter ? job.fitter.id : null}
                    triggerChange={triggerChange}
                    editable={!job.is_defect}
                  />
                </Form.Control>
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Estimated Hours</Form.Label>
                  <Form.Input
                    type={"number"}
                    name={"estimated_hours"}
                    value={job.estimated_hours}
                    onChange={onDefectChange}
                  />
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Vehicle Arrived</Form.Label>
                    <Form.Checkbox
                      type="checkbox"
                      name="vehicle_arrived"
                      onChange={() => {
                          onCheck("vehicle_arrived");
                        }
                      }
                      checked={job.vehicle_arrived}
                      disabled={job.is_defect || job.is_enquiry}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Wash Needed</Form.Label>
                    <Form.Checkbox
                      type="checkbox"
                      name="wash_needed"
                      onChange={() => {
                          onWashNeededTick("wash_needed", workTypeObjects)
                        }
                      }
                      checked={job.wash_needed}
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Control>
                    <Form.Label>Wash Complete</Form.Label>
                    <Form.Checkbox
                      type="checkbox"
                      name="wash_needed"
                      onChange={() => {
                        onCheck("wash_complete");
                      }}
                      checked={job.wash_complete}
                      disabled={!job.wash_needed || job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Job Description</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      name="job_description"
                      onChange={handleChange}
                      value={job.job_description}
                      required
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Work Description</Form.Label>
                  <Form.Control>
                    <Form.Textarea
                      name="job_description"
                      value={job.work_descriptions}
                      disabled={true}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Job Card Creation Date</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"date"}
                      name={"date_created"}
                      onChange={handleChange}
                      value={job.date_created}
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Booked In Date</Form.Label>
                <Form.Field className={"has-addons"}>
                  <Form.Control>
                    <Form.Input
                      type="date"
                      name="book_in_date"
                      onChange={handleChange}
                      value={job.book_in_date || ""}
                      required
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                  <Button
                    color={"info"}
                    onClick={() => setShowFitterHours(!showFitterHours)}
                  >
                    ?
                </Button>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Workshop Date</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="date"
                      name="workshop_date"
                      onChange={handleChange}
                      value={job.workshop_date || ""}
                      required
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Finish Date</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="date"
                      name="finish_date"
                      onChange={handleChange}
                      value={job.finish_date || ""}
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            {showFitterHours &&
                  <FitterHours
                      job={job}
                      data={fitterHoursData}
                      loaded={(fitterHoursLoaded && !fitterLoading)}
                      startInput={fitterStartInput}
                      endInput={fitterEndInput}
                      startDate={fitterStart}
                      endDate={fitterEnd}
                      selectedDate={selectedDate}
                      setSelectedDate={setSelectedDate}
                  />
            }
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Drop Off ETA</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="time"
                      name="drop_off_eta"
                      onChange={handleChange}
                      value={job.drop_off_eta || ""}
                      required
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Collection ETA</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="time"
                      name="collection_eta"
                      onChange={handleChange}
                      value={job.collection_eta || ""}
                      required
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Job Mileage</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="mileage"
                      onChange={handleChange}
                      value={String(job.mileage)}
                      disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Expected Mileage</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="expected_mileage"
                      onChange={handleChange}
                      value={String(job.expected_mileage)}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Workshop Invoice Number</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      name="workshop_invoice_number"
                      data-testid={"workshop-invoice-number"}
                      onChange={handleChange}
                      value={job.workshop_invoice_number}
                      disabled={job.is_defect || hasApprovedWork(job, "po_approved")}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Workshop Invoice Date</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="date"
                      name="workshop_invoice_date"
                      data-testid={"workshop-invoice-date"}
                      onChange={handleChange}
                      value={job.workshop_invoice_date}
                      disabled={job.is_defect || job.is_enquiry}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Workshop Credit Note Number</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      name="workshop_credit_note_number"
                      data-testid={"workshop-credit-number"}
                      onChange={handleChange}
                      value={job.workshop_credit_note_number}
                      disabled={job.is_defect || hasApprovedWork(job, "po_approved")}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Force To Customer Invoicing</Form.Label>
                <Form.Checkbox
                  name={"force_to_invoice"}
                  checked={job.force_to_invoice}
                  onChange={() => onCheck("force_to_invoice")}
                  disabled={job.is_defect || !job.approved}
                />
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Customer 1 Invoice Number</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      name="customer_invoice_number"
                      data-testid={"customer1-invoice-number"}
                      onChange={handleChange}
                      value={job.customer_invoice_number}
                      disabled={job.is_defect || hasApprovedWork(job, "invoice_approved")}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Customer 1 Invoice Date</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="date"
                      name="customer1_invoice_date"
                      data-testid={"customer1-invoice-date"}
                      onChange={handleChange}
                      value={job.customer1_invoice_date}
                      disabled={job.is_defect || hasApprovedWork(job, "invoice_approved")}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Customer 1 Amount Paid</Form.Label>
                <Form.Input
                  type={"number"}
                  value={job.customer1_paid_amount}
                  onChange={handleChange}
                  name={"customer1_paid_amount"}
                />
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Customer 1 Payment Method</Form.Label>
                <Form.Select
                  name={"customer1_payment_method"}
                  value={job.customer1_payment_method}
                  onChange={handleChange}
                >
                  {customerPaymentOptions.map(method => (
                      <option value={method.value}>{method.name}</option>
                  ))}
                </Form.Select>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Customer 2 Invoice Number</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      name="customer2_invoice_number"
                      data-testid={"customer2-invoice-number"}
                      onChange={handleChange}
                      value={job.customer2_invoice_number}
                      disabled={job.is_defect || hasApprovedWork(job, "invoice_approved")}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Field>
                  <Form.Label>Customer 2 Invoice Date</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="date"
                      name="customer2_invoice_date"
                      data-testid={"customer2-invoice-date"}
                      onChange={handleChange}
                      value={job.customer2_invoice_date}
                      disabled={job.is_defect || hasApprovedWork(job, "invoice_approved")}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Customer 2 Amount Paid</Form.Label>
                <Form.Input
                  type={"number"}
                  value={job.customer2_paid_amount}
                  onChange={handleChange}
                  name={"customer2_paid_amount"}
                />
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Customer 2 Payment Method</Form.Label>
                <Form.Select
                  name={"customer2_payment_method"}
                  value={job.customer2_payment_method}
                  onChange={handleChange}
                >
                  {customerPaymentOptions.map(method => (
                      <option value={method.value}>{method.name}</option>
                  ))}
                </Form.Select>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Table size={"fullwidth"}>
                  <thead>
                  <tr>
                    <th>Comment</th>
                    <th>Date Created</th>
                    <th>Creator</th>
                    <th>Remove</th>
                  </tr>
                  </thead>
                  <tbody>
                    {job.comments_list.map((value, index) => (
                      <Comment
                        job={job.id}
                        quote={job.quote}
                        key={value.id || value.key}
                        index={index}
                        comment={value}
                        updateComments={updateComment}
                        removeComment={removeComment}
                        disabled={job.is_defect}
                      />
                    ))}
                  </tbody>
                </Table>
                <Columns>
                  <Columns.Column>
                    <Button
                      tabIndex={-1}
                      type="button"

                      color="info"
                      onClick={addComment}
                      disabled={job.is_defect}
                    >
                      Add Comment
                    </Button>
                  </Columns.Column>
                </Columns>
              </Columns.Column>
            </Columns>
            <Columns>
               <Columns.Column>
                <Form.Field>
                  <Form.Label>History</Form.Label>
                  <Form.Control>
                    <Form.Textarea
                        onChange={handleHistoryChange}
                        value={job.history}
                        disabled={job.is_defect}
                    />
                  </Form.Control>
                </Form.Field>
              </Columns.Column>
            </Columns>
          </form>
        </Box>
        <Box>
          <h1 className="title">Work</h1>
          <Box>
            {/*<WorkTotalsSection*/}
            {/*  items={job.work_items}*/}
            {/*  quote={job.quote}*/}
            {/*  customer_name={job.customer ? job.customer.display_name : ""}*/}
            {/*  customer2_name={*/}
            {/*    job.customer2 ? job.customer2.display_name : ""*/}
            {/*  }*/}
            {/*/>*/}
            <Columns>
              <Columns.Column>
                {job.work_items.map((value, index) => (
                  <WorkSection
                    job={job.id}
                    quote={job.quote}
                    workTypes={workTypes}
                    workTypeObjects={workTypeObjects}
                    key={value.id || value.key}
                    customer={job.customer}
                    supplier={job.workshop}
                    hireCustomer={job.customer2}
                    vehicle={job.vehicle}
                    index={index}
                    workItem={value}
                    update_work={updateWork}
                    remove_work_item={removeWorkItem}
                    onSearchPartClick={onSearchPartClick}
                    invoiced={invoiced}
                    lcv_job={job.department === "LCV Centre"}
                    appDefaults={appDefaults}
                    trackingOptionObjects={trackingOptionObjects}
                    trackingOptions={trackingOptions}
                  />
                ))}
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Button
                  tabIndex={-1}
                  id="add-workitem"
                  color="info"
                  className="is-pulled-left"
                  onClick={() =>addWorkItem("")}
                  disabled={!!invoiced || job.is_defect || job.is_enquiry}
                >
                  Add Work Item
                </Button>
                <Button
                  tabIndex={-1}
                  color="info"
                  style={{marginLeft: '10px'}}
                  onClick={() => {
                    setWorkModalState({...workModalState, modalOpen: true})
                  }}
                  disabled={!!invoiced || job.is_defect || job.is_enquiry}
                >
                  Search Work Lookups
                </Button>
              </Columns.Column>
            </Columns>
            {!(!!job.id) &&
            <DefaultWorkItemsSection
              workItems={defaultWork}
              job={job}
              removedWorkItems={removedDefaultWorkItems}
              addRemovedWorkItem={onRemoveDefaultItem}
              removeRemovedWorkItem={onAddDefaultItem}
            />
            }
          </Box>
        </Box>
        {existingJobs &&
        <Box>
          <Columns>
            <Columns.Column>
              <Heading>Existing Jobs/Quotes</Heading>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Table size={"fullwidth"} bordered>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Customer</th>
                    <th>Workshop</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                {existingJobs.map(item => (
                    <tr>
                      <td className={"on-hover-highlight clickable"} onClick={() => onClick(item)}>{item.id}</td>
                      <td>{item.itemType}</td>
                      <td>{item.description || item.job_description}</td>
                      <td>
                        {item.itemType === "Job"
                            ? item.is_defect
                                ? null
                                : item.customer2
                                    ? item.customer2
                                    : item.customer
                                      ? item.customer
                                      : ""
                            :
                            item.customer2
                                ? item.customer2
                                : item.customer
                                      ? item.customer
                                      : ""
                        }
                      </td>
                      <td>
                        {item.workshop}
                      </td>
                      <td>{readableDate(item.itemType === 'Job' ? item.workshop_date : item.provisional_start_date)}</td>
                    </tr>
                ))}
                </tbody>
              </Table>
            </Columns.Column>
          </Columns>
          {job.vehicle && job.vehicle.id &&
            <Columns>
              <Columns.Column>
                <Table bordered size={"fullwidth"}>
                  <thead>
                    <tr>
                      <th>Inspection Type</th>
                      <th>Inspection Workshop</th>
                      <th>Expiry Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {job.vehicle.inspections && job.vehicle.inspections.map(inspection => (
                        <VehicleInspectionRow
                          inspection={inspection}
                          view={"popup"}
                        />
                    ))}
                  </tbody>
                </Table>
              </Columns.Column>
            </Columns>
          }
        </Box>
        }
        {job.id && !job.is_defect && !job.is_enquiry &&
            <MovementSection
              movements={movements}
              rateData={movementRates}
              dataFresh={dataFresh}
              endpoint={props.endpoint}
              typeData={movementTypes}
              movementTypeObjects={movementTypeObjects}
              driverObjects={driverObjects}
              driverData={drivers}
              departments={departments}
              departmentObjects={departmentObjects}
            />
        }
        <Box>
          <Form.Field>
            <div className="control">
              <Button onClick={handleSave} fullwidth color="info">
                Save Job
              </Button>
            </div>
          </Form.Field>
          <Form.Field>
            <div className="control">
              <Button onClick={() => setImageModalOpen(true)} fullwidth color="info">
                {"Show Attached Images ("+images.length+")"}
              </Button>
            </div>
          </Form.Field>
          {job.id && !job.is_defect && !job.is_enquiry && (
              <Form.Field>
                <Form.Control>
                  <Button
                    color={"info"}
                    fullwidth
                    onClick={(e) => {
                      e.preventDefault();
                      setMovementModal(true);
                    }}
                  >
                    Create Movement
                  </Button>
                </Form.Control>
              </Form.Field>
          )}
          {job.id && job.status === "READY_FOR_COLLECTION" && (
            <Form.Field>
              <div className="control">
                <Button
                  onClick={() => {
                    handleStatus("COLLECTED");
                  }}
                  fullwidth
                  color="success"
                >
                  Mark As Collected
                </Button>
              </div>
            </Form.Field>
          )}
          {job.id && !job.is_defect && !job.is_enquiry &&(
              <>
            <Form.Field>
              <ReactToPrint
                trigger={() => (
                  <Button color="warning" fullwidth>
                    Print Workshop Job Sheet
                  </Button>
                )}
                content={() => printJobSheetRef.current}
                bodyClass="print-landscape"
                pageStyle="@page {
                  size: A4 landscape;
                }"
              />
            </Form.Field>
            <Form.Field>
              <ReactToPrint
                trigger={() => (
                  <Button color="warning" fullwidth>
                    Print Vehicle Check-in Sheet
                  </Button>
                )}
                content={() => printVehicleCheckInRef.current}
                bodyClass="print-portrait"
                pageStyle="@page {
                  size: A4 portrait;
                }"
              />
            </Form.Field>
            <Form.Field>
              <Button
                color={"warning"}
                onClick={() => setPrintOptionsModalOpen(true)}
                fullwidth
              >
                Print Customer Quote
              </Button>
            </Form.Field>
            </>
          )}
          {
            (job.is_defect || job.is_enquiry) &&
              <Form.Field>
              <div className="control" >
                <Button
                  onClick={() => {
                    triggerChange({is_defect: false, is_enquiry: false})
                  }}
                  fullwidth
                  color="success"
                  id={"defect-to-job"}
                  data-testid="defect-to-job"
                >
                  Turn Into Job
                </Button>
              </div>
            </Form.Field>
          }
          {job.is_defect &&
            <Form.Field>
                <div className="control" >
                  <Button
                    onClick={() => {
                      setContactModalOpen(true);
                    }}
                    fullwidth
                    color="success"
                    id={"defect-to-quote"}
                    data-testid="defect-to-quote"
                  >
                    Turn Defect Into Quote
                  </Button>
                </div>
            </Form.Field>
          }
          {job.is_enquiry &&
            <Form.Field>
                <div className="control" >
                  <Button
                    onClick={() => {
                      setEnquiryToQuoteModalOpen(true);
                    }}
                    fullwidth
                    color="success"
                    id={"enquiry-to-quote"}
                    data-testid="enquiry-to-quote"
                  >
                    Turn Enquiry Into Quote
                  </Button>
                </div>
            </Form.Field>
          }
          {
          job.id && !job.approved && !job.is_defect && !job.is_enquiry && job.status === "IN_PROGRESS" &&
            <Form.Field>
              <div className="control" >
                <Button
                  onClick={() => {
                    handleStatus("RETURNED_FROM_WORKSHOP");
                  }}
                  fullwidth
                  color="success"
                  id={"Returned"}
                  data-testid="Returned"
                >
                  Returned From Workshop
                </Button>
              </div>
            </Form.Field>
          }
          {job.id && !job.approved && (job.status === "READY_FOR_COLLECTION" || job.status === "COLLECTED") && (
            <Form.Field>
              <div className="control">
                <Button
                  onClick={() => {
                    setApproveModalOpen(true);
                    getAllJobsQuotes(job.vehicle);
                    if(associatedItems.length > 0) {
                      setSimilarModal(true);
                    }
                  }}
                  fullwidth
                  color="success"
                >
                  Approve Job
                </Button>
              </div>
            </Form.Field>
          )}
          {job.id && job.status === "RETURNED_FROM_WORKSHOP" && (
            <Form.Field>
              <div className="control">
                <Button
                  onClick={() => {
                    handleStatus("READY_FOR_COLLECTION").then(() =>{
                      if(job.customer && job.customer.workshop_instructions.filter((instruction) => filterInstructions(instruction)).length > 0 ||
                          job.customer2 && job.customer2.workshop_instructions.filter((instruction) => filterInstructions(instruction)).length > 0){
                        setInstructionModalOpen(true);
                      }
                      if(job.vehicle && !job.vehicle.key){
                        setKeyModal(true);
                      }
                    })
                  }}
                  fullwidth
                  color="success"
                >
                  Ready For Collection
                </Button>
              </div>
            </Form.Field>
          )}
          {job.id && (
            <Form.Field>
              <Form.Control>
                <Button
                  onClick={e => {
                    e.preventDefault();
                    setDeleteModalOpen(true);
                  }}
                  fullwidth
                  color="danger"
                >
                  Delete Job
                </Button>
              </Form.Control>
            </Form.Field>
          )}
        </Box>
        <PartSearchModal
          {...partsModalState}
          setModalState={setPartsModalState}
          selectPart={searchSelectPart}
        />
        <WorkSearchModal
          {...workModalState}
          setModalState={setWorkModalState}
          selectWork={searchSelectWork}
          supplier={job.workshop}
        />
        <DeleteWarningModal
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          onDelete={handleDelete}
        />
        <ApprovalModal
          open={approveModalOpen}
          setOpen={setApproveModalOpen}
          handleChange={handleChange}
          job={job}
          workItems={job.work_items}
          onApprove={handleApprove}
          isJob={true}
        />
        <ExistingItemModal
          open={similarModal}
          setOpen={setSimilarModal}
          items={associatedItems}
          onContinue={handleContinue}
          history={props.history}
          type={"Job Card"}
          vehicle={job.vehicle}
          hideType={true}
        />
        <KeyChangeModal
          open={keyModal}
          setOpen={setKeyModal}
          keys={keys}
          triggerChange={triggerChange}
          vehicle={job.vehicle}
          save={vehicleSave}
          selectedKey={job.vehicle ? job.vehicle.key : {}}
          onClear={onKeyClear}
        />
        <ImageModal
          job={job}
          open={imageModalOpen}
          setOpen={setImageModalOpen}
          dataFresh={dataFresh}
          type={'job'}
          images={images}
          imagesLoaded={imagesLoaded}
        />
        <ContactModal
          job={job}
          open={contactModalOpen}
          setOpen={setContactModalOpen}
          endpoint={props.endpoint}
          dataFresh={dataFresh}
          triggerChange={triggerChange}
          handleSave={defectToQuote}
        />
        <WorkshopInstructions
          contact1={job.customer}
          contact2={job.customer2 ? job.customer2 : {}}
          open={instructionModalOpen}
          setOpen={setInstructionModalOpen}
          filterInstructions={filterInstructions}
        />
        <ToQuoteModal
          open={enquiryToQuoteModalOpen}
          setOpen={setEnquiryToQuoteModalOpen}
          job={job}
          endpoint={props.endpoint}
          history={props.history}
        />
        <VehicleMileageWarning
          open={mileageWarningModal}
          setOpen={setMileageWarningModal}
          job={job}
        />
        {job.id &&
        <CreateMovement
          open={movementModal}
          setOpen={setMovementModal}
          dataFresh={dataFresh}
          autoFill={autoFill}
          endpoint={props.endpoint}
          movementRateObjects={movementRateObjects}
          movementRateOptions={movementRates}
          movementTypeObjects={movementTypeObjects}
          movementTypeOptions={movementTypes}
          driverObjects={driverObjects}
          driverOptions={drivers}
          workTypes={workTypes}
          workTypeObjects={workTypeObjects}
          departments={departments}
          departmentObjects={departmentObjects}
          movementRateParams={props.utilsParam}
          setMovementRateParams={handleUtilsParam}
        />
        }
        <PrintJobQuoteOptionsModal
          setOpen={setPrintOptionsModalOpen}
          open={printOptionsModalOpen}
          data={job}
        />
        <div style={{display: "none"}}>
          <div>
            <PrintJob data={job} ref={printJobSheetRef}/>
            <PrintVehicleCheckInSheet data={job} ref={printVehicleCheckInRef}/>
          </div>
        </div>
      </div>
    );
}

export default JobForm;
